import { getRequest } from './wagtail';

const API_URL = '/wt';

export async function getOrganizationChart(holding, urlData, options) {
    const params = { holding, ...urlData };
    return await getRequest(
        `${API_URL}/fenix/connections/org_chart/`,
        params,
        options
    );
}

export async function getPeople(params, options) {
    return await getRequest(
        `${API_URL}/fenix/connections/people/`,
        params,
        options
    );
}

export async function getPerson(personId, options) {
    return await getRequest(
        `${API_URL}/fenix/connections/people/${personId}/`,
        {},
        options
    );
}
